import { lazy } from 'react';

export const RefreshPageLazy = lazy(() => import('./refresh-page'));
